var React = require('react');

function TrampolinLogoWhite (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"logo"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("path",{"fill":"white","d":"M23,20.2L21.3,9.3c-0.2-5-4.3-9-9.4-9c-5.2,0-9.3,4.2-9.3,9.4L1,20.2c0,0.2,0.1,0.3,0.2,0.3L4.6,21c0.2,0,0.3-0.1,0.3-0.2\n\tl0.7-4.2c1.1,1,2.5,1.8,4,2.2v6.5c0,0.2,0.1,0.3,0.3,0.3h3.4c0.2,0,0.3-0.1,0.3-0.3V19c1.9-0.3,3.6-1.2,4.9-2.4l0.7,4.3\n\tc0,0.2,0.2,0.3,0.3,0.2l3.3-0.5C22.9,20.5,23,20.3,23,20.2 M17.1,9.8c0,2.8-2.3,5.2-5.2,5.2c-2.8,0-5.2-2.3-5.2-5.2\n\tc0-2.9,2.3-5.2,5.2-5.2C14.8,4.5,17.1,6.9,17.1,9.8","key":2})]);
}

TrampolinLogoWhite.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 24 26.1","style":{"enableBackground":"new 0 0 24 26.1"},"xmlSpace":"preserve"};

module.exports = TrampolinLogoWhite;

TrampolinLogoWhite.default = TrampolinLogoWhite;
